// extracted by mini-css-extract-plugin
module.exports = {"radioInputBox":"RadioInput-module--radioInputBox--1Wb7f","inputBox":"RadioInput-module--inputBox--9ylrr"};